export default __webpack_public_path__ + "static/media/me.3198986a.webp";